import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserSignIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.14242 4.44554C5.14242 3.10497 6.22916 2.01823 7.56972 2.01823C8.91028 2.01823 9.99702 3.10497 9.99702 4.44554C9.99702 5.7861 8.91028 6.87284 7.56972 6.87284C6.22916 6.87284 5.14242 5.7861 5.14242 4.44554ZM7.56972 0.143234C5.19363 0.143234 3.26742 2.06944 3.26742 4.44554C3.26742 6.82163 5.19363 8.74784 7.56972 8.74784C9.94582 8.74784 11.872 6.82163 11.872 4.44554C11.872 2.06944 9.94582 0.143234 7.56972 0.143234ZM7.56979 8.89173C4.05136 8.89173 0.851562 11.247 0.851562 14.54C0.851562 15.0577 1.2713 15.4775 1.78906 15.4775C2.30683 15.4775 2.72656 15.0577 2.72656 14.54C2.72656 12.6242 4.70855 10.7667 7.56979 10.7667C10.431 10.7667 12.413 12.6242 12.413 14.54C12.413 15.0577 12.8327 15.4775 13.3505 15.4775C13.8683 15.4775 14.288 15.0577 14.288 14.54C14.288 11.247 11.0882 8.89173 7.56979 8.89173Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgUserSignIn;
